module.exports = __webpack_public_path__ + "img/linkedin-32px.df307c31.svg";